import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FieldRadio.scss'

class FieldRadio extends React.Component {
	render() {
		const { fieldId, error, options, ...rest } = this.props
		return (
			<span styleName="wrapper">
				{options
					? options.map((el, i) => (
							<label key={'radio' + el.label + i}>
								<input
									key={'radio' + el.label + i}
									type="radio"
									name={fieldId}
									value={el.value}
								/>
								{el.label}
							</label>
						))
					: 'Nothing to choose from!'}
			</span>
		)
	}
}
FieldRadio.propTypes = {
	id: React.PropTypes.string,
	error: React.PropTypes.bool
}

export default CSSModules(FieldRadio, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FieldRadio.js